<template>
  <div class="solutionDetail padding80">
    <Header :current="0"></Header>
    <LeiMonContent :LeiMonContent="Main[type]"></LeiMonContent>
    <Footer></Footer>
  </div>
</template>

<script>
import solutionDetail from "./solution";
export default {
  name: "solutionDetail",
  data() {
    return {
      Main: solutionDetail,
      type: ""
    };
  },
  created() {
    this.type = this.$route.query.type;
    window,scrollTo(0,0)
  },
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="less"></style>
